import { updateServiceConsent } from '@store/service-consent';

type UCEventServiceName = 'Vimeo' | 'YouTube Video' | 'Mapbox';

type UCEventServiceStatus = Record<UCEventServiceName, boolean>;
type UCEventBaseDetail = {
    action: string;
    event: string;
    type: string;
    ucCategory: Record<string, boolean>;
};

type UCWindowEventDetail = UCEventBaseDetail & UCEventServiceStatus;

type UCEvent = CustomEvent<UCWindowEventDetail>;

const USERCENTRICS_WINDOW_EVENT = 'usercentrics::window-event';
const USERCENTRICS_CONSENT_CHANGE_EVENT = 'consent_status';

const createServiceConsentTracker = () => {
    const mapToStore = ({
        Vimeo: vimeo,
        ['YouTube Video']: youtube,
        Mapbox: mapbox,
    }: UCEventServiceStatus) => {
        updateServiceConsent({ vimeo, mapbox, youtube });
    };

    const init = () => {
        if (window.__INIT_CONSENT__ !== null) {
            mapToStore(window.__INIT_CONSENT__);
        }
        window.addEventListener(USERCENTRICS_WINDOW_EVENT, ({ detail }: UCEvent) => {
            if (detail?.event == USERCENTRICS_CONSENT_CHANGE_EVENT) {
                mapToStore(detail);
            }
        });
    };

    return { init };
};

export const serviceConsentTracker = createServiceConsentTracker();
